import React, { FC } from 'react'
import { Select, Modal, Form } from 'antd'
import { t } from '../util'
// import '../index.less'
interface IProps {
  isSettingModalOpen: boolean
  handleSettingCancel: () => void
  p2pMsgReceiptVisible: boolean
  teamMsgReceiptVisible: boolean
  addFriendNeedVerify: boolean
  needMention: boolean
  teamManagerVisible: boolean
  enableV2CloudConversation: boolean
  locale: "zh" | "en" | "ru" | "cht" | "tr" | "ara" | "pt" | "th" | "vie" | "fra" | "kor" | "fr"
  aiStream: boolean
}
const SettingModal: FC<IProps> = ({
  isSettingModalOpen,
  handleSettingCancel,
  p2pMsgReceiptVisible,
  teamMsgReceiptVisible,
  addFriendNeedVerify,
  needMention,
  teamManagerVisible,
  enableV2CloudConversation,
  aiStream,
  locale,
}) => {
  return (
    <Modal
      title={t('settingText')}
      open={isSettingModalOpen}
      onCancel={handleSettingCancel}
      footer={null}
      width={locale === 'zh' ? 420 : 460}
    >
      <Form labelCol={{ span: locale === 'zh' ? 12 : 14 }}>
        {/* <Form.Item label={intl.formatMessage({id: 'sdk版本选择'})}>
          <Select
            options={[
              { label: 'IM SDK', value: 1 },
              { label: 'IM Elite SDK ', value: 2 },
            ]}
            style={{ width: '150px' }}
            value={sdkVersion}
            onChange={(value) => {
              sessionStorage.setItem('sdkVersion', value.toString())
              window.location.reload()
            }}
          />
        </Form.Item> */}
        <Form.Item label={t('p2pMsgVisibleModeText')}>
          <Select
            options={[
              { label: t('yesText'), value: true },
              { label: t('noText'), value: false },
            ]}
            style={{ width: '150px' }}
            value={p2pMsgReceiptVisible}
            onChange={(value) => {
              sessionStorage.setItem('p2pMsgReceiptVisible', value.toString())
              window.location.reload()
            }}
          />
        </Form.Item>
        <Form.Item label={t('teamMsgVisibleModeText')}>
          <Select
            options={[
              { label: t('yesText'), value: true },
              { label: t('noText'), value: false },
            ]}
            style={{ width: '150px' }}
            value={teamMsgReceiptVisible}
            onChange={(value) => {
              sessionStorage.setItem('teamMsgReceiptVisible', value.toString())
              window.location.reload()
            }}
          />
        </Form.Item>
        <Form.Item label={t('addFriendMode')}>
          <Select
            options={[
              { label: t('needVerifyText'), value: true },
              { label: t('notNeedVerifyText'), value: false },
            ]}
            style={{ width: '150px' }}
            value={addFriendNeedVerify}
            onChange={(value) => {
              sessionStorage.setItem('addFriendNeedVerify', value.toString())
              window.location.reload()
            }}
          />
        </Form.Item>
        <Form.Item label={t('needMentionText')}>
          <Select
            options={[
              { label: t('yesText'), value: true },
              { label: t('noText'), value: false },
            ]}
            style={{ width: '150px' }}
            value={needMention}
            onChange={(value) => {
              sessionStorage.setItem('needMention', value.toString())
              window.location.reload()
            }}
          />
        </Form.Item>
        <Form.Item label={t('teamManagerEnableText')}>
          <Select
            options={[
              { label: t('yesText'), value: true },
              { label: t('noText'), value: false },
            ]}
            style={{ width: '150px' }}
            value={teamManagerVisible}
            onChange={(value) => {
              sessionStorage.setItem('teamManagerVisible', value.toString())
              window.location.reload()
            }}
          />
        </Form.Item>
        <Form.Item label={t('enableV2CloudConversationText')}>
          <Select
            options={[
              { label: t('yesText'), value: true },
              { label: t('noText'), value: false },
            ]}
            style={{ width: '150px' }}
            value={enableV2CloudConversation}
            onChange={(value) => {
              sessionStorage.setItem(
                'enableV2CloudConversation',
                value.toString()
              )
              window.location.reload()
            }}
          />
        </Form.Item>
        <Form.Item label={t('aiStreamText')}>
          <Select
            options={[
              { label: t('yesText'), value: true },
              { label: t('noText'), value: false },
            ]}
            style={{ width: '150px' }}
            value={aiStream}
            onChange={(value) => {
              sessionStorage.setItem('aiStream', value.toString())
              window.location.reload()
            }}
          />
        </Form.Item>
      </Form>
    </Modal>
  )
}

export default SettingModal
